import React from 'react';
import {SvgIcon, SvgIconProps} from "@mui/material";

const ToursTipsIconSvg = (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.26136 21H14.7386M12.1818 6.28849C12.1818 6.28849 13.3774 6.2909 14.5682 7.5C15.759 8.7091 15.7614 9.9231 15.7614 9.9231M15.0795 18.2308V17.7589C15.0795 17.1923 15.6914 16.9305 15.6914 16.9305C17.0218 16.0202 18.0296 14.7007 18.5669 13.1659C19.1042 11.631 19.1426 9.96167 18.6765 8.403C18.2105 6.84433 17.2645 5.47847 15.9775 4.50601C14.6905 3.53354 13.1303 3.00572 11.5261 3.00005C9.92187 2.99438 8.35812 3.51116 7.06449 4.47451C5.77087 5.43785 4.81554 6.797 4.33881 8.35233C3.86208 9.90767 3.88907 11.5772 4.41581 13.1158C4.94256 14.6545 5.9413 15.981 7.26536 16.9008C7.26536 16.9008 7.92045 17.1923 7.92045 17.8846V18.2308C7.92045 18.75 8.26136 19.0962 8.77273 19.0962H14.2273C14.7386 19.0962 15.0795 18.75 15.0795 18.2308Z"
            stroke="currentColor" strokeLinecap="round"/>
    </svg>

)
const ToursTipsIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {ToursTipsIconSvg}
    </SvgIcon>
);
export default ToursTipsIcon
